import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-card border-t border-border-medium py-12">
      <div className="container mx-auto px-4 py-12">
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8"> */}
          {/* Brand & Description */}
          {/* <div className="space-y-4">
            <h3 className="heading-5 text-text-primary">Mahesh Rajaram</h3>
            <p className="body-small text-text-secondary">
              1:1 consulting to remove bottlenecks and build simple systems that scale.
            </p>
            <div className="flex space-x-4">
              <a
                href="tel:+918885295958"
                className="flex items-center space-x-2 text-text-secondary hover:text-secondary-trust transition-colors"
              >
                <Phone size={16} />
                <span className="body-small">+91 88852 95958</span>
              </a>
            </div>
            <div className="flex space-x-4">
              <a
                href="https://wa.me/918885295958"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-text-secondary hover:text-secondary-success transition-colors"
              >
                <MessageCircle size={16} />
                <span className="body-small">WhatsApp</span>
              </a>
            </div>
            <div className="flex space-x-4">
              <a
                href="mailto:processticks@gmail.com"
                className="flex items-center space-x-2 text-text-secondary hover:text-secondary-trust transition-colors"
              >
                <Mail size={16} />
                <span className="body-small">processticks@gmail.com</span>
              </a>
            </div>
          </div> */}

          {/* Quick Links */}
          {/* <div className="space-y-4">
            <h4 className="heading-6 text-text-primary">Quick Links</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="body-small text-text-secondary hover:text-secondary-trust transition-colors">
                Home
              </Link>
              <Link to="/how-i-help" className="body-small text-text-secondary hover:text-secondary-trust transition-colors">
                How I Help
              </Link>
              <Link to="/start" className="body-small text-text-secondary hover:text-secondary-trust transition-colors">
                Book Session
              </Link>
              <Link to="/about" className="body-small text-text-secondary hover:text-secondary-trust transition-colors">
                About
              </Link>
            </nav>
          </div> */}

          {/* Legal */}
          {/* <div className="space-y-4">
            <h4 className="heading-6 text-text-primary">Legal</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/privacy" className="body-small text-text-secondary hover:text-secondary-trust transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="body-small text-text-secondary hover:text-secondary-trust transition-colors">
                Terms of Service
              </Link>
            </nav>
          </div>
        </div> */}

        {/* Bottom */}
        {/* <div className="border-t border-border-medium mt-8 pt-8"> */}
          <div className="space-y-4 md:space-y-0">
            <p className="body-small text-text-secondary text-center">
              © {currentYear} Victorical White Horses. All rights reserved.
            </p>
          </div>
        {/* </div> */}
      </div>
    </footer>
  );
};

export default Footer;